const Status = new class Status{
  Massnahme_angelegt  = 1;
  Massnahme_gebilligt  = 2;
  Massnahme_bewilligt  = 3;
  Massnahme_inaktiv  = 4;
  Massnahme_abgelehnt  = 5;
  Massnahme_abgeschlossen  = 6;
  Zuwendungsantrag_angelegt  = 7;
  Zuwendungsantrag_eingereicht  = 8;
  Zuwendungsantrag_angelegtRueckfrage  = 9;
  Zuwendungsantrag_freigegeben  = 10;
  Zuwendungsantrag_freigegebenRueckfrage  = 11; //eingereicht nach Rückfrage
  Zuwendungsantrag_inaktivNachEingereicht  = 12;
  Zuwendungsantrag_inaktivNachFreigegeben  = 13;
  Zuwendungsantrag_gebilligt  = 15;
  Zuwendungsantrag_abgelehnt  = 16;
  ZBau_inBearbeitung  = 18;
  ZBau_freigegeben  = 19;
  ZBau_gesperrt  = 55;
  Bewilligung_angelegt  = 20;
  Bewilligung_bewilligt  = 21;
  Bewilligung_storniert  = 22;
  Bewilligung_RueckmeldungAngelegtMT  = 24;
  Bewilligung_RueckmeldungAngelegtSGD  = 25;
  Bewilligung_RueckmeldungAngelegtMUFV  = 26;
  Bewilligung_RueckmeldungAngelegtSystem  = 27;
  Bewilligung_RueckmeldungEingereicht  = 28;
  Bewilligung_RueckmeldungVorgeschlagen  = 29;
  Bewilligung_gebilligt  = 30;
  Bewilligung_abgelehnt  = 31;
  Bewilligung_RotabsetzungAngelegt  = 32;
  Bewilligung_RotabsetzungAngelegtMUFV  = 49;
  Bewilligung_RotabsetzungVorgeschlagen  = 33;
  Bewilligung_bewilligtMUFV  = 50;
  Bewilligung_UmbewilligungAngelegt  = 52;
  Auszahlungsantrag_angelegt  = 34;
  Auszahlungsantrag_angelegtNachRueckfrage  = 56;
  Auszahlungsantrag_eingereicht  = 35;
  Auszahlungsantrag_veranlasst  = 36;
  Auszahlungsantrag_abgelehnt  = 37;
  Auszahlungsantrag_Zahlungseingang_vermerkt  = 53;
  Verwendungsnachweis_angelegt  = 38;
  Verwendungsnachweis_angelegtNachRueckfrage  = 57;
  Verwendungsnachweis_eingereicht  = 39;
  Verwendungsnachweis_geprueft  = 40;
  Foerderprogramm_angelegt  = 42;
  Foerderprogramm_freigegeben  = 43;
  Foerderprogramm_gebilligt  = 46;
  Foerderprogramm_abgelaufen  = 47;
  RegstFoerderprogramm_VorschlagFreigegeben  = 45;
  RegstFoerderprogramm_VorschlagAngelegt  = 44;
  RegstFoerderprogramm_Neu  = 48;
  RegstFoerderprogramm_gebilligt  = 54;
  Ausgabenposition_angelegt = 58;
  Ausgabenposition_eingereicht = 59;
  Ausgabenposition_geprueft = 60;
  VorzeitigerVorhabenbeginn_Angelegt = 65;
  VorzeitigerVorhabenbeginn_EingereichtSgd = 66;
  VorzeitigerVorhabenbeginn_Freigegeben = 67;
  VorzeitigerVorhabenbeginn_Zugestimmt = 68;
  VorzeitigerVorhabenbeginn_Abgelehnt = 69;
  VorzeitigerVorhabenbeginn_EingereichtMufv = 70;
  VorzeitigerVorhabenbeginn_Inaktiv = 71;
};

const Statuswechsel = new class Statuswechsel {
  RueckrufVonSGD  = 75;
  RueckrufVonMUFV  = 76;
  RueckrufSGD  = 77
};

const Titelart = new class Titelart {
  Darlehen = 1;
  Zuschuss = 2;
  Zinszuschuss = 3
};

const Anlagenart = new class Anlagenart {
  Entgeltberechnung = 1;
  KommStellungnahme = 2;
  Uebersichtsplan = 3;
  Erlaeuterungsbericht = 4;
  Kostenplan = 5;
  Nachweis_Notwendigkeit = 6;
  AnlageSachbericht = 11;
  Bau_Stellungnahme = 12;
  Massnahmenbeschreibung = 13;
  ZASonstiges = 14;
  Pruefvermerk = 16;
  SonstigesMA = 17;
  SonstigesVN = 19;
  Begr_Angemessenheit = 21;
  FotodokumentationVorher = 22;
  FotodokumentationNachher = 23;
  SNUBescheide = 24;
  SNUZahlungsanweisungen = 25;
  Verwendungsnachweis = 26;
  Bestaetigung_Landkreis = 27;
  Notwendigkeit = 28;
  ZA_FotodokumentationVorher = 29;
  Kostenschaetzung = 30;
  Elementarschadenversicherung = 31;
  Submissionsergebnis = 34;
  BerechnungZuwendungZweckverband = 35;
  VNSonstigeZuwendungen = 36;
};

const DocumentTyp = new class DocumentTyp {
  Bescheid = 1;
  Bewilligungsvermerk = 2;
  ZustimmungZumVorzeitigenBaubeginn = 3;
  AufnahmeInsFoerderprogramm = 4;
  AnschreibenZumGeprueftenVerwendungsnachweis = 5;
  Tilgungsplan = 6
};


const NachrichtenArt = new class NachrichtenArt {
  Wiedervorlage = 1;
  Nachricht = 2;
  Statuswechsel = 3;
  Aenderungsantrag = 4
};

const Foerderrichtlinie = new class Foerderrichtlinie {
  Foerderrichtlinie2008 = 3;
  Foerderrichtlinie2013 = 4;
  Foerderrichtlinie2018 = 5;
  FoerderrichtlinieAufbau2021 = 6;
  Foerderrichtlinie2021 = 7;
};

const Tabelle = new class Tabelle {
MIP_MASSNAHME  = 1;
MIP_ZUWENDUNGSANTRAG  = 2;
MIP_ZBAU  = 3;
MIP_BEWILLIGUNG  = 4;
MIP_AUSZAHLUNGSANTRAG  = 5;
MIP_VN_VERWENDUNGSNACHWEIS  = 6;
APPL_PERSON = 9;
MIP_MASSNAHMETRAEGER = 10;
MIP_VORZ_VORHABENBEGINN = 13
};

const Reiter = new class Reiter {
  ZA_Allgemeine_Daten = 1;
  ZA_Beschreibung = 2;
  ZA_Finanzplanung = 3;
  ZA_Grunderwerb = 4;
  ZA_Erklaerungen = 5;
  ZA_Kommunalaufsichtliche_Stellungnahme = 6;
  ZA_Wasserrecht = 7;
  ZA_Anlagen = 8;
  ZA_Notwendigkeit = 25;
  ZA_Angemessenheit = 26;
  ZA_Baufachliche_Stellungnahme = 27;
  ZA_Pruefung_Gesamtkosten = 33;
  ZA_Vorschlag_Zuwendung_SGD = 34;
  ZA_MIP_Verteilung = 35;
  ZA_Vorzeitiger_Vorhabenbeginn = 36;
  ZA_Hinweise_zur_Massnahme = 38;

  BW_Mittelzuweisung = 9;
  BW_HHVermerk = 10;
  BW_Bescheid = 11;

  AA_Auszahlungsantrag = 20;
  AA_Ausgabenliste = 21;
  AA_Dokumente = 22;
  AA_Pruefvermerk = 30;
  AA_Tilgungsplan = 31;
  AA_ZZ_Tranche = 32;

  VN_Zusammenfassung = 12;
  VN_Weitere_Pruefvermerke = 13;
  VN_Einnahmen = 14;
  VN_Ausgabenübersicht = 15;
  VN_Ausgabenliste = 16;
  VN_Grunderwerb = 17;
  VN_Erklaerungen = 18;
  VN_Dokumente = 19;
  VN_Erfolgsnachweis = 37;
}

const Bescheidtyp =  new class Bescheidtyp {
MIP_Erstbescheid  = 1;
MIP_Umbewilligung  = 2;
MIP_Rueckmeldung  = 3;
MIP_Rotabsetzung  = 4
};

const Bescheidart = new class Bescheidart {
  MIP_Umbewilligung  = 3;
  MIP_AenderungHaushaltsstelle  = 4;
  MIP_BitteUmUmbewilligung  = 6;
  MIP_VerlaengerungAbrufzeitraum  = 7;
  MIP_RueckmeldungWiederbewilligung = 8;
  MIP_Mehrkostenfoerderung  = 9;
};

const Finanzierungsart =  new class Finanzierungsart {
  MIP_Festbetragsfinanzierung  = 2
};

const Massnahmenkategorie =  new class Massnahmenkategorie {
  Ohne  = -1;
  Unbekannt  = 0;
  MIP_Wasserversorgung  = 1;
  MIP_Abwasser  = 2;
  MIP_Flussgebietsentwicklung  = 3;
  MIP_Gutachten  = 8;
  MIP_Aufbauhilfe  = 9
};

const Massnahmenart = new class Massnahmenart {
  Ohne  = -1;
  Unbekannt  = 0;
  Wasserversorgung_Herstellung = 1; //1.1
  Wasserversorgung_Ausbau = 2; //1.2
  Wasserversorgung_Messeinrichtung = 25; // 1.4
  Abwasser_Herstellung = 3; // 2.1.1
  Abwasser_Ausbau = 4; //2.2.1
  Abwasser_Kanalsanierung = 26; //2.2.4
  Abwasser_Kanalsanierung_ohne_Schadensklassifizierung = 33; //2.2.5
  Abwasser_Kanalsanierung_2018 = 40;//2.2.6
  Abwasser_Kanalsanierung_ohne_Schadensklassifizierung_2018 = 41;//2.2.7
  Abwasser_Ausbau_Energie = 27; //2.2.2
  Abwasser_Ausbau_WRRL = 29; //2.2.3
  Gutachten = 19; // 6.1
  Gutachten_TSM = 44; // 6.1.1
  Gutachten_Benchmarking = 45; // 6.1.2
  Gutachten_Kanalsanierungskonzept = 46; // 6.1.3
  Gutachten_Energie = 47; // 6.1.4
  Gutachten_Sonstige = 48; // 6.1.5
  Trinkwasserspender  = 21; // 7
  KleinKlaeranlage_Bau  = 31; //2.1.2
  KleinKlaeranlage_Betrieb  = 32; // 2.1.3
  Flussgebietsentwicklung_Grunderwerb_depr  = 6; // 3.2
  Flussgebietsentwicklung_Konzepte  = 8; // 3.5
  NaturnaheUnterhaltung = 37; // 3.4.2 --> 3.1.3
  Renaturierung_FOERIWWV_2_5  = 38; // 3.1.1
  Wiederherstellung_Durchgaengigkeit  = 39; // 3.1.2
  Fischschutz_Fischabstieg = 42; // 3.1.4
  Wiederherstellung_Durchgaengigkeit_WKA = 57; // 3.1.5
  Aufbauhilfe_Trinkwasserversorgungsanlagen = 50; // 9.1
  Aufbauhilfe_Hochwasserschutz = 54; // 9.5
  Aufbauhilfe_WasserbaulAnlagen = 55; // 9.6
  Abwasser_Kanalsanierung_2021 = 56; // 2.2.8
  Hochwasser_Starkregen_Erstellung = 58; // 4.6.1
  Hochwasser_Starkregen_Fortschreibung = 59; // 4.6.2
  Stauanlagen_Wasserspeicher = 60; // 4.7
  Grundwasserneubildung = 61; // 4.8
  Interkommunale_Zusammenarbeit_Gewaesserentwicklung = 62; // 6.1.6
  Kommunale_Umweltbildungsprojekte = 63; // 6.1.7
  Wasserversorgung_Resilienz = 64; // 1.5
  Abwasser_Resilienz = 65;// 2.2.9
  Flussgebietsentwicklung_Grunderwerb = 69; // 3.2.1
  Flussgebietsentwicklung_Grunderwerb_Flut = 70; // 3.2.2
};

const Ausgabenkategorie =  new class Ausgabenkategorie {
  ohneKategorie  = 0;
  klaeranlageMischsystem = 1
};

const AusgabenkategoriePausch = new class AusgabenkategoriePausch {
  Schmutz = 20;
  Misch = 21;
};

const Kostenkategorie = new class Kostenkategorie {
  Grunderwerb = 1;
  Pflanzmassnahmen = 2;
  Pflegemassnahmen = 7;
  Ingenieurarbeiten = 8;
  PlusElemente = 9;
  Baunebenkosten = 10;
  Umsatzsteuer = 11;
  Bauarbeiten = 12;
};

const KostenkategorieTyp = new class KostenkategorieTyp {
  Renaturierung = 1
};

const AusgabenkategorieTyp = new class AusgabenkategorieTyp {
  OhneKategorie  = 0;
  Wasserversorgung = 1;
  Abwasser = 2;
  Kanalsanierung = 3;
  Kanalsanierung_2018 = 4
};

const Rechtsform =  new class Rechtsform {
  KommGebietskoerperschaft  = 1;
  Eigenbetrieb = 2;
  ZweckverbandVollfunktion = 6;
  ZweckverbandTeilfunktion = 15;
};

const Vorlage =  new class Vorlage {
  WiederaufbauBestaetigungLandkreis = 2;
  WiederaufbauKostenschaetzung  = 3;
  ZweckverbandTeilfunktion = 4;
};

const TextbausteinAuto = new class TextbausteinAuto {
   ZZMittel = 1;
   EEGErklaerungStromerzeugung = 2;
   Bautafel = 3;
   Kofinanzierung = 4;
   VereinfachterVN = 5;
   Grunderwerb = 6;
   Kanalsanierung2_2_8 = 7;
   Mindestdeckung = 9;
   WegfallKommStellungnahme = 10;
   BescheidRechnungshof = 11;
}

/**
 *  MIP_MASSNAHME  = 1;
    MIP_ZUWENDUNGSANTRAG  = 2;
    MIP_ZBAU  = 3;
    MIP_BEWILLIGUNG  = 4;
    MIP_AUSZAHLUNGSANTRAG  = 5;
    MIP_VN_VERWENDUNGSNACHWEIS  = 6;
    APPL_PERSON = 9;
    MIP_MASSNAHMETRAEGER = 10;
    MIP_SUBMISSION_ANTRAG = 12;
    MIP_VORZ_VORHABENBEGINN = 13
 */
const VorgangVersion = new class VorgangVersion {
  Tab2_MT_vor24  = 1;
  Tab2_SGD_KommStellOpt  = 3;
  Tab2_MT_Erklaerungen  = 4;
  Tab2_SGD_VorschlagSGD_MIP3  = 4;
  Tab2_MT_Finanzplan_MIP3  = 5;
  Tab2_MT_SNU_Foerderung  = 6;
  Tab2_MUFV_MIPVerteilung_MIP3  = 2;
  Tab6_MT_Erfolgsnachweis  = 2;
  Tab4_MUFV_Umbewilligung  = 2;
  Tab4_MUFV_Baumassnahme = 3;
  Tab2_MT_3_5_0  = 7;
  Tab5_MT_Vorauszahlung  = 2;
  Tab2_SGD_Notwendigkeit = 6;
  Tab2_SGD_WRRLPlaner = 7;
  Tab2_MT_3_8_0 = 8; // FoeRi 2021
  Tab2_SGD_3_8_0 = 8;
  Tab2_SGD_4_0_0  = 108;
  Tab2_MUFV_4_0_0  = 103;
  Tab2_MT_4_0_0  = 108;
  Tab4_MT_4_0_0  = 104;
  Tab5_MT_4_0_0  = 103;
  Tab6_MT_4_0_0  = 103;
  Tab6_MT_4_2_0 = 104;
  Tab2_MT_4_2_0  = 109;
  Tab2_MT_4_2_5  = 110;
  Tab2_MT_4_2_7  = 111;
  Tab13_MT_4_0_0  = 1;
  Tab13_MT_4_2_0  = 2;
};

const Haltung = new class Haltung {
  SanierungErneuert = 0;
  SanierungRenoviert = 1;
}

export default  {
  Status,
  Statuswechsel,
  Titelart,
  Anlagenart,
  NachrichtenArt,
  Foerderrichtlinie,
  Tabelle,
  Bescheidtyp,
  Bescheidart,
  Finanzierungsart,
  Massnahmenkategorie,
  Massnahmenart,
  Ausgabenkategorie,
  AusgabenkategorieTyp,
  AusgabenkategoriePausch,
  Rechtsform,
  VorgangVersion,
  DocumentTyp,
  Kostenkategorie,
  KostenkategorieTyp,
  Reiter,
  Vorlage,
  TextbausteinAuto,
  Haltung
}
